import { useMemo } from 'react';
import { ColumnDescription } from 'react-bootstrap-table-next';
import { Tooltip } from '@mui/material';

import { PlanFeaturesTypes } from '~globals/types/enums';
import { ItemExtended } from '~services/item/types';
import {
  OrderClientInfo,
  // OrderMFlexQR,
  ExpirationDateInfo,
  SourceImportTypeInfo,
  OrderHistoryEventInfo,
} from '~components/index';

import DashboardVariantV2GiverContentInTransitTabDataTableActions from './Actions';

export const useInTransitTabDataTableColumns =
  (): ColumnDescription<ItemExtended>[] => {
    const columns = useMemo<ColumnDescription<ItemExtended>[]>(
      () => [
        {
          dataField: 'title',
          text: 'Nombre de contacto',
          classes: 'truncated-two-lines',
          formatter: (_cell, row) => (
            <OrderClientInfo
              name={row.title}
              trackingCode={row.trackingCode}
              duplicated={row.duplicated}
            />
          ),
          hidden: false,
          headerStyle: { width: 228 },
          sort: true,
        },
        {
          dataField: 'address',
          text: 'Dirección',
          classes: 'truncated-two-lines',
          formatter: (cell) => <span>{cell}</span>,
          hidden: false,
          headerStyle: { width: 300 },
          sort: true,
        },
        {
          dataField: 'addressNotes',
          text: 'Notas de dirección',
          classes: 'truncated-two-lines',
          formatter: (cell) => {
            if (!cell) return null;

            return (
              <Tooltip title={cell} placement="bottom-start">
                <span style={{ maxLines: 1 }}>{cell}</span>
              </Tooltip>
            );
          },
          hidden: true,
          headerStyle: { width: 200 },
          sort: true,
        },
        {
          dataField: 'referenceId',
          text: 'Nro. de Orden',
          classes: 'truncated-two-lines',
          formatter: (_cell, row) => {
            if (!row.referenceId) return null;

            return (
              <Tooltip title={row.referenceId} placement="bottom-start">
                <span>{row.referenceId}</span>
              </Tooltip>
            );
          },
          hidden: false,
          headerStyle: { width: 120 },
          sort: true,
        },
        // {
        //   dataField: 'qrcode',
        //   text: 'QR',
        //   classes: 'truncated-two-lines',
        //   formatter: (_cell, row) => {
        //     if (!row.qrcode) return null;

        //     return (
        //       <OrderMFlexQR.IconWithTooltipInfo
        //         qrData={row.qrcode}
        //         referenceId={row.referenceId}
        //       />
        //     );
        //   },
        //   validSubscriptionFeature: {
        //     validFeature: PlanFeaturesTypes.LimitPaid,
        //   },
        //   headerAlign: 'center',
        //   align: 'center',
        //   hidden: false,
        //   headerStyle: { width: 60 },
        // },
        // {
        //   dataField: 'tags',
        //   text: 'Grupo',
        //   classes: 'truncated-two-lines',
        //   formatter: (cell) => <span>{cell}</span>,
        //   hidden: true,
        //   headerStyle: { width: 120 },
        // },
        {
          dataField: 'maxDeliveryDateTime',
          text: 'Fecha de vencimiento',
          classes: 'truncated-two-lines',
          formatter: (cell) => <ExpirationDateInfo expirationDate={cell} />,
          hidden: false,
          headerStyle: { width: 150 },
          sort: true,
        },
        {
          dataField: 'contactEmail',
          text: 'Correo electrónico',
          classes: 'truncated-two-lines',
          hidden: true,
          headerStyle: { width: 220 },
          sort: true,
        },
        {
          dataField: 'contactPhone',
          text: 'Telefono',
          classes: 'truncated-two-lines',
          hidden: true,
          headerStyle: { width: 200 },
          sort: true,
        },
        {
          dataField: 'contactMobile',
          text: 'Celular / Whatsapp',
          classes: 'truncated-two-lines',
          hidden: true,
          headerStyle: { width: 200 },
          sort: true,
        },
        {
          dataField: 'zipCode',
          text: 'Código postal',
          classes: 'truncated-two-lines',
          hidden: true,
          headerStyle: { width: 90 },
          sort: true,
        },
        {
          dataField: 'sourceImportTypeId',
          text: 'Medio de importación',
          classes: 'truncated-two-lines',
          hidden: false,
          formatter: (_cell, row) => (
            <SourceImportTypeInfo sourceImportTypeId={row.sourceImportTypeId} />
          ),
          headerStyle: { width: 120 },
          sort: true,
        },
        {
          dataField: 'externalStatusType',
          isDummyField: true,
          text: 'Estado Flex',
          classes: 'truncated-two-lines',
          hidden: true,
          formatter: (_cell, row) => {
            if (!row.externalStatusType) return null;

            return (
              <Tooltip
                title={row.externalStatusType.description}
                placement="bottom-start"
              >
                <span>{row.externalStatusType.description}</span>
              </Tooltip>
            );
          },
          headerStyle: { width: 180 },
        },
        {
          dataField: 'itemHistory',
          isDummyField: true,
          text: 'Último evento',
          classes: 'truncated-two-lines',
          formatter: (_cell, row) => {
            if (!row.lastItemStoryType || !row.lastItemStory) return null;

            return (
              <OrderHistoryEventInfo
                title={row.lastItemStoryType.description}
                description={row.lastItemStory.description}
              />
            );
          },
          validSubscriptionFeature: {
            validFeature: PlanFeaturesTypes.LimitPaid,
          },
          hidden: false,
          headerStyle: { width: 200 },
        },
        {
          dataField: 'actions',
          isDummyField: true,
          text: '',
          classes: 'truncated-two-lines',
          formatter: (_cell, row) => (
            <DashboardVariantV2GiverContentInTransitTabDataTableActions
              data={row}
            />
          ),
          headerAlign: 'center',
          align: 'center',
          headerStyle: { width: 70 },
        },
      ],
      [],
    );

    return columns;
  };
